if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.submitButtonText =
          this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }


      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add(
          'loading'
        );

        this.querySelector(
          '.loading__spinner'
        )?.classList.remove('hidden');


        const config =
          fetchConfig('javascript');

        config.headers[
          'X-Requested-With'
        ] = 'XMLHttpRequest';

        delete config.headers[
          'Content-Type'
        ];


        const formData =
          new FormData(this.form);


        if (this.cart) {

          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(
            document.activeElement
          );
        }


        config.body = formData;


        try {

          const fetchResponse =
            await fetch(
              `${routes.cart_add_url}`,
              config
            );

          const response =
            await fetchResponse.json();


          /* =========================================
             SHOPIFY RETURNED AN ERROR
          ========================================== */

          if (response.status) {

            publish(
              PUB_SUB_EVENTS.cartError,
              {
                source: 'product-form',
                productVariantId:
                  formData.get('id'),

                errors:
                  response.errors ||
                  response.description,

                message:
                  response.message,
              }
            );


            this.handleErrorMessage(
              response.description
            );


            /*
              IMPORTANT FIX

              Shopify can sometimes add the
              maximum allowed quantity to cart
              while still returning a quantity
              error.

              Refresh the cart immediately so
              the drawer and cart badge reflect
              what Shopify actually accepted.
            */

            await this.refreshCartAfterError(
              formData.get('id')
            );


            const soldOutMessage =
              this.submitButton.querySelector(
                '.sold-out-message'
              );


            /*
              Do NOT permanently disable
              Add to Cart just because a
              quantity error occurred.
            */

            if (soldOutMessage) {

              const description =
                (
                  response.description || ''
                ).toLowerCase();


              /*
                Only treat this as genuinely
                sold out if Shopify indicates
                that explicitly.
              */

              if (
                description.includes(
                  'sold out'
                ) ||
                description.includes(
                  'not available'
                )
              ) {

                this.submitButton.setAttribute(
                  'aria-disabled',
                  true
                );

                this.submitButtonText
                  ?.classList.add(
                    'hidden'
                  );

                soldOutMessage
                  .classList.remove(
                    'hidden'
                  );

                this.error = true;

              } else {

                this.error = false;

              }

            } else {

              this.error = false;

            }


            return;
          }


          /* =========================================
             NORMAL SUCCESS
          ========================================== */

          if (!this.cart) {

            window.location =
              window.routes.cart_url;

            return;
          }


          const startMarker =
            CartPerformance.createStartingMarker(
              'add:wait-for-subscribers'
            );


          if (!this.error) {

            await publish(
              PUB_SUB_EVENTS.cartUpdate,
              {
                source: 'product-form',

                productVariantId:
                  formData.get('id'),

                cartData: response,
              }
            );


            CartPerformance
              .measureFromMarker(
                'add:wait-for-subscribers',
                startMarker
              );
          }


          this.error = false;


          const quickAddModal =
            this.closest(
              'quick-add-modal'
            );


          if (quickAddModal) {

            document.body.addEventListener(
              'modalClosed',
              () => {

                setTimeout(() => {

                  CartPerformance.measure(
                    'add:paint-updated-sections',
                    () => {

                      this.cart.renderContents(
                        response
                      );

                    }
                  );

                });

              },
              {
                once: true
              }
            );


            quickAddModal.hide(true);

          } else {

            CartPerformance.measure(
              'add:paint-updated-sections',
              () => {

                this.cart.renderContents(
                  response
                );

              }
            );

          }


        } catch (e) {

          console.error(
            'Holoverse cart error:',
            e
          );


        } finally {

          this.submitButton.classList.remove(
            'loading'
          );


          if (
            this.cart &&
            this.cart.classList.contains(
              'is-empty'
            )
          ) {

            this.cart.classList.remove(
              'is-empty'
            );

          }


          if (!this.error) {

            this.submitButton.removeAttribute(
              'aria-disabled'
            );

          }


          this.querySelector(
            '.loading__spinner'
          )?.classList.add(
            'hidden'
          );


          CartPerformance.measureFromEvent(
            'add:user-action',
            evt
          );

        }
      }



      /* =============================================
         REFRESH CART AFTER QUANTITY ERROR
      ============================================== */

      async refreshCartAfterError(
        productVariantId
      ) {

        if (!this.cart) {
          return;
        }


        try {

          const sectionsToRender =
            this.cart.getSectionsToRender();


          const sectionIds =
            sectionsToRender.map(
              (section) => section.id
            );


          /*
            Fetch the real cart state
          */

          const cartUrl =
            window.routes?.cart_url ||
            '/cart';


          /*
            Ask Shopify to re-render
            the cart drawer and cart badge.
          */

          const sectionsUrl =
            new URL(
              window.location.href
            );


          sectionsUrl.searchParams.set(
            'sections',
            sectionIds.join(',')
          );


          const [
            cartResponse,
            sectionsResponse
          ] = await Promise.all([

            fetch(
              `${cartUrl}.js`,
              {
                headers: {
                  Accept:
                    'application/json'
                }
              }
            ),

            fetch(
              sectionsUrl.toString()
            )

          ]);


          if (
            !cartResponse.ok ||
            !sectionsResponse.ok
          ) {

            throw new Error(
              'Unable to refresh cart'
            );

          }


          const cartData =
            await cartResponse.json();


          const renderedSections =
            await sectionsResponse.json();


          /*
            Create the same structure that
            Publisher normally receives from
            /cart/add.js
          */

          const refreshedCart = {
            ...cartData,

            id:
              productVariantId,

            sections:
              renderedSections
          };


          /*
            Tell other Publisher components
            that the cart changed.
          */

          await publish(
            PUB_SUB_EVENTS.cartUpdate,
            {
              source:
                'product-form',

              productVariantId:
                productVariantId,

              cartData:
                refreshedCart
            }
          );


          /*
            Immediately redraw cart drawer
            + cart count bubble.
          */

          this.cart.renderContents(
            refreshedCart
          );


          /*
            Cart is no longer empty
          */

          if (
            this.cart.classList.contains(
              'is-empty'
            )
          ) {

            this.cart.classList.remove(
              'is-empty'
            );

          }


        } catch (error) {

          console.error(
            'Unable to refresh cart after quantity error:',
            error
          );

        }

      }



      /* =============================================
         ERROR MESSAGE
      ============================================== */

      handleErrorMessage(
        errorMessage = false
      ) {

        if (this.hideErrors) {
          return;
        }


        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );


        if (!this.errorMessageWrapper) {
          return;
        }


        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );


        this.errorMessageWrapper
          .toggleAttribute(
            'hidden',
            !errorMessage
          );


        if (errorMessage) {

          this.errorMessage.textContent =
            errorMessage;

        }

      }



      /* =============================================
         SUBMIT BUTTON
      ============================================== */

      toggleSubmitButton(
        disable = true,
        text
      ) {

        if (disable) {

          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );


          if (text) {

            this.submitButtonText
              .textContent = text;

          }

        } else {

          this.submitButton.removeAttribute(
            'disabled'
          );


          this.submitButtonText.textContent =
            window.variantStrings.addToCart;

        }

      }



      get variantIdInput() {

        return this.form.querySelector(
          '[name=id]'
        );

      }

    }
  );
}